import React, {useRef} from 'react';

import {HighlightableTextWrapper} from 'app/comments/components/HighlightableTextWrapper';
import {ClickToEditButton} from 'app/components/general/ClickToEditButton';
import {ListMessage} from 'app/components/general/ListMessage';
import {HIGHLIGHT_POLICY_STEPID} from 'app/general/structures/UserContentContainer/utils/highlightUtils';
import {ImagesCarousel} from 'app/general/widgets/ImagesCarousel';
import {policyHasAnyContent} from 'app/policies/components/PolicyEditPage/utils';
import {ProcedureStepFiles} from 'app/procedures/components/ProcedureStepFiles';
import {gt} from 'app/utils/i18n';

import type {PolicyContentType} from 'app/policies/types';
type Props = {
  content: Omit<PolicyContentType, 'name' | 'url' | 'html_url'>;
  editable: boolean;
  versionId: number;
  objectId: number;
};

export const ViewPolicyContent = ({
  content,
  editable,
  versionId,
  objectId,
}: Props) => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  return policyHasAnyContent(content) ? (
    <div ref={contentRef}>
      <HighlightableTextWrapper
        objectId={objectId}
        versionId={versionId}
        stepId={HIGHLIGHT_POLICY_STEPID}
        targetNullStepid={true}
        content={content.content}
        contentType={'policyversion'}
        innerRef={contentRef}
      />

      {content.videos.length > 0 ||
      content.embeds.length > 0 ||
      content.images.length > 0 ? (
        <div className="images">
          <ImagesCarousel
            onClick={(e) => e.stopPropagation()}
            images={[...content.videos, ...content.embeds, ...content.images]}
          />
        </div>
      ) : null}
      {content.files.length > 0 ? (
        <ProcedureStepFiles files={content.files} />
      ) : null}
    </div>
  ) : (
    <ListMessage>
      {editable ? (
        <ClickToEditButton>
          {gt('Click here to edit policy content.')}
        </ClickToEditButton>
      ) : (
        gt('This policy has no content.')
      )}
    </ListMessage>
  );
};
